import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Card, ProgressBar, Text } from "react-native-paper";
import type { IconType } from "../types";
import { useAppTheme } from "../useAppTheme";
import Box from "./Box";
import Button from "./Button";

type Props = {
	title: string;
	subtitle: string;
	handleClickCard: () => void;
	icon: IconType;
	numItems: number;
	numCompleted: number;
	loading?: boolean;
	button: {
		cta: string;
		icon: IconType;
		handleClick: () => void;
	};
	disabled?: boolean;
};
const DiagnosticCard = ({
	title,
	subtitle,
	handleClickCard,
	icon,
	numItems,
	numCompleted,
	loading,
	disabled,
	button,
}: Props) => {
	const isCompleted = numCompleted >= numItems;

	const theme = useAppTheme();

	const progress = numCompleted / numItems;
	return (
		<Card
			onPress={handleClickCard}
			mode={isCompleted ? "elevated" : "outlined"}
			style={{
				overflow: "hidden",
				opacity: disabled ? 0.5 : 1,
			}}
		>
			<Card.Content>
				<Box gap={8}>
					<Box gap={8} flexDirection="row">
						<Icon name={icon} size={24} color={theme.colors.onSurface} />
						<Box flex={1}>
							<Text numberOfLines={2} variant="titleSmall">
								{title}
							</Text>
							<Text numberOfLines={2} variant="bodySmall">
								{subtitle}
							</Text>
						</Box>
					</Box>
					<Box paddingTop={10}>
						<ProgressBar
							style={{
								height: 8,
							}}
							progress={progress}
						/>
					</Box>
				</Box>
			</Card.Content>
			{button && (
				<Card.Actions
					style={{
						padding: 16,
					}}
				>
					<Button
						icon={button.icon}
						onPress={button.handleClick}
						disabled={disabled}
						loading={loading}
						mode="text"
					>
						{button.cta}
					</Button>
				</Card.Actions>
			)}
		</Card>
	);
};

export default DiagnosticCard;
